import { formatDateForInput } from "@/utils/dateUtils";

/**
 * Map GET work-item-by-id payload (already passed through {@link mapWorkItemFromApiPayload})
 * into partial {@link CreateTaskForm} field values + description (rich text separate from RHF).
 */
export function mapWorkItemToCreateTaskDefaults(wi) {
  if (wi == null || typeof wi !== "object") {
    return { formPartial: {}, description: "" };
  }

  const typeId =
    wi.typeId != null && String(wi.typeId).trim() !== "" ? String(wi.typeId).trim() : "";
  const projId =
    wi.projectId != null && String(wi.projectId).trim() !== "" ? String(wi.projectId).trim() : "";

  const parentRaw =
    wi.parentId ?? (typeof wi.parent === "object" && wi.parent != null ? wi.parent.id : null);

  let envArray = [];
  const envRaw = wi.bugDetails?.environment ?? wi.environment;
  if (envRaw != null && typeof envRaw === "string" && envRaw.trim() !== "") {
    envArray = envRaw
      .split(",")
      .map((s) => String(s).trim())
      .filter(Boolean);
  } else if (Array.isArray(envRaw)) {
    envArray = envRaw.map((x) => String(x).trim()).filter(Boolean);
  }

  const estimateStr =
    wi.estimate != null && String(wi.estimate).trim() !== ""
      ? String(wi.estimate).trim()
      : wi.originalEstimate != null && String(wi.originalEstimate).trim() !== ""
        ? String(wi.originalEstimate).trim()
        : "";

  const startStr = formatDateForInput(wi.startDate ?? "");
  const dueStr = formatDateForInput(wi.dueDate ?? "");

  const formPartial = {
    type: typeId,
    project: projId,
    parentId: parentRaw != null ? String(parentRaw).trim() : "",
    priority: wi.priorityId != null ? String(wi.priorityId).trim() : "",
    assignee: wi.assigneeId != null ? String(wi.assigneeId).trim() : "",
    summary: wi.title ?? "",
    attachments: [],
    originalEstimate: estimateStr,
    storyPoints:
      wi.storyPoints != null && String(wi.storyPoints).trim() !== ""
        ? String(wi.storyPoints).trim()
        : "",
    startDate: startStr,
    dueDate: dueStr,
    severityId:
      wi.bugDetails?.severityId != null
        ? String(wi.bugDetails.severityId).trim()
        : wi.severityId != null
          ? String(wi.severityId).trim()
          : "",
    environment: envArray,
    reproductionSteps:
      wi.bugDetails?.reproductionSteps != null &&
      String(wi.bugDetails.reproductionSteps).trim() !== ""
        ? String(wi.bugDetails.reproductionSteps).trim()
        : wi.reproductionSteps != null
          ? String(wi.reproductionSteps).trim()
          : "",
    reasonOfBug: wi.bugDetails?.reasonOfBug != null ? String(wi.bugDetails.reasonOfBug).trim() : "",
    isBacklog: Boolean(wi.isBacklog === true || wi.isBacklog === 1),
  };

  const description =
    wi.description != null && String(wi.description).trim() !== "" ? String(wi.description) : "";

  return { formPartial, description };
}
